<template>
  <div class="gallery Page">
    <div class="Page-Content Page-Content1">
      <div class="gallery-group">
        <div class="gallery-item growFromScaleAnimation" v-for="(data, i) in nowdata" :key="i" @click="showIMG(data)">
          <div class="item-img">
            <img class="" :src="data.cover" alt="" />
          </div>
        </div>
      </div>
    </div>

    <!-- 其他媒体 -->
    <div v-if="showMedia" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-color: black;z-index: 2000;">
      <video v-if="showMediaData.type=='video'" style="width: 100%;height: 100%;" :src="showMediaData.media" playsinline autoplay muted loop controls></video>
      <iframe style="width: 100%;height: 100%;" v-if="showMediaData.type=='vr'" :src="showMediaData.media" frameborder="0"></iframe>
      <div class="Media-swiper" v-if="showMediaData.type=='img'">
        <swiper class="swiper swiperGallery" :options="swiperOption" ref="swiperOption" >
          <swiper-slide  v-for="item,i in nowImg" :key="i" >
            <img ondragstart="return false;" :src="item" alt="">
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" style="left: 5%; top: 45%">
          <img src="@/assets/btn/left1.png" alt="" />
        </div>
        <div class="swiper-button-next" style="right: 5%; top: 45%">
          <img src="@/assets/btn/right1.png" alt="" />
        </div>
      </div>
      <div @click="showMedia=false" class="close-btn">Close</div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      showMedia:false,
      showMediaData:{},
      nowdata: [
        { index:1,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v1-2.jpg"),media:"img1" },
        { index:2,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-V2.jpg"),media:"img1" },
        { index:3,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v3-opt1.jpg"),media:"img1" },
        { index:4,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v5.jpg"),media:"img1" },
        { index:5,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v6-2222.jpg"),media:"img1" },
        { index:6,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v4-1.jpg"),media:"img1" },
        { index:7,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v7.jpg"),media:"img1" },
        { index:8,name: "IMG",show:true, type: "img", cover: require("@/assets/172-img/172-6C6D LaVille-v8.jpg"),media:"img1" },
      ],
      imglistData:{
        img1:[
        require("@/assets/172-img/172-6C6D LaVille-v1-2.jpg"),
        require("@/assets/172-img/172-6C6D LaVille-V2.jpg"),
        require("@/assets/172-img/172-6C6D LaVille-v3-opt1.jpg"),
        require("@/assets/172-img/172-6C6D LaVille-v5.jpg"),
        require("@/assets/172-img/172-6C6D LaVille-v6-2222.jpg"),
        require("@/assets/172-img/172-6C6D LaVille-v4-1.jpg"),
        require("@/assets/172-img/172-6C6D LaVille-v7.jpg"),
        require("@/assets/172-img/172-6C6D LaVille-v8.jpg"),
        ],
        img3:[],
      },
      nowImg:[],
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        loopedSlides: 0, // looped slides should be the same
        // spaceBetween: 10,
        centeredSlides: true,
        loop:true,
        // autoplay: {
        //     delay: 5000, // 轮播间隔时间，单位为毫秒
        //     disableOnInteraction: false, // 用户操作后是否禁止自动轮播
        //   },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

      },
    };
  },
  methods: {
    showVr(item){
      this.showMedia = true;
      this.showMediaData = item
    },
    showIMG(item){
      if(!item.show) return;
      this.showMedia = true;
      this.showMediaData = item
      if (item.type == 'img') {
        this.nowImg = this.imglistData[item.media]
        this.$nextTick(() => {
            this.$refs.swiperOption.swiper.slideTo(item.index);
            this.$refs.swiperOption.swiper.update();
                
            });
        return;
      }
      

    }
  },
  mounted() {
    // this.$nextTick(()=>{
    //   const top = this.$refs.swiperOption.swiper
    //   const bottom = this.$refs.swiperOptionBottom.swiper
    //   top.controller.control = bottom
    //   bottom.controller.control = top
    // })
  },
};
</script>

<style lang="less">

.close-btn{
  position: absolute;
  top: 49%;
  right: 20px;
  color: black;
  background-color: white;
  padding: 5px;
  cursor: pointer;
  border-radius: 5px;
  z-index: 999;
}

.Media-swiper{
  position: absolute;
  width: 100%;
  height: 100%;
  .swiper-slide,.swiperGallery {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    img {
      max-height: 5rem;
      max-width: 5rem;
    }
  }
}



.gallery {
  .Page-Content1{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .gallery-group{
    width: 80%;
    margin: auto;
    // margin-top: 35px;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-evenly;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    // color: white;
    .gallery-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      // width: 320px;
      height: 35vh;
      margin: 20px;
      .item-img{
        position: relative;
        width: 100%;
        height: 90%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px;
        // filter: brightness(50%);
      }
      }

    }
  }

}

@media screen and (max-width:800px) {
  .gallery-group {
    grid-template-columns: repeat(1, 1fr) !important;
  }
  .Page-Content1{
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  .close-btn {
    top: 10px;
    right: 10px;
  }
}


</style>

